/* tslint:disable */
/* eslint-disable */
/**
 * Munchi Dashboard Server Api
 * The Munchi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const ProviderEnum = {
    Wolt: 'Wolt',
    MunchiOnline: 'MunchiOnline',
    MunchiKiosk: 'MunchiKiosk',
    MunchiPos: 'MunchiPos',
    UberEats: 'UberEats',
    Foodora: 'Foodora',
    Bolt: 'Bolt',
    MunchiKioskV2: 'MunchiKioskV2',
    Kiosk: 'Kiosk',
    WoltStorefront: 'WoltStorefront',
    Storefront: 'Storefront',
    MunchiPay: 'MunchiPay'
} as const;

export type ProviderEnum = typeof ProviderEnum[keyof typeof ProviderEnum];



